import "./FavoritesList.scss"
import React, {useEffect, useState} from "react";
import {UnitCard} from "../unit/UnitCard";
import {useLocalStorage} from "usehooks-ts";

export function FavoritesList() {

  const [lsFavorites] = useLocalStorage<number[]>("storefront-favorites", [])
  const [data, setData] = useState<any[]>([])

  // useEffect(()=>{
  //   fetch("/api/storefront/groups?groups="+JSON.stringify(lsFavorites))
  //     .then(r => r.json())
  //     .then(r => setData(r.data))
  // }, [lsFavorites])

  const List = () => data.map(g => <article key={g.id} data-component="UnitCard">
    <UnitCard currency={"XXX"} unitGroup={g} floorSelector={false}/>
  </article>)

  return <div data-component="FavoritesList"><main>
    {data.length?<List/>:<h4>Нічого немає</h4>}
  </main></div>

}